import { formatWorkflowSource } from "context/workflowReference";

// The record's own `definition`; `source` is set when that definition lives in another revision.
export function definitionLabel(execution) {
  const resolved = execution && execution["definition"];
  if ( !resolved ) {
    return { alias: null, source: null };
  }
  const foreign = resolved["revision_id"] !== execution["revision_id"];
  return { alias: resolved["alias"] || null, source: foreign ? formatWorkflowSource(execution["workflow"]) : null };
}
